export default __webpack_public_path__ + "dist/media/Active.5e7e7971.svg";